// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"Preloader_btn-primary__B8F7b","root":"Preloader_root__3XUiG","rotating":"Preloader_rotating__1mD1A","fadeIn":"Preloader_fadeIn__1DYkY"};